import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import Button from 'components/button/Button';

const AddUnitTypeButton = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { uid: propertyUid } = useParams();

  const goToAddUnitType = () => {
    navigate(`/property/${propertyUid}/add/unit-type`);
  };

  return (
    <Button
      $colorScheme="green"
      onClick={goToAddUnitType}
      data-testid="add-unit-type-button"
    >
      {t('common.pageTitles.property/:uid/add/unit-type', {
        nsSeparator: false,
      })}
    </Button>
  );
};

export default AddUnitTypeButton;
